<template>
  <v-sheet
    tag="section"
    tile
    :class="{ 'grey lighten-3': !$vuetify.theme.dark, 'grey darken-4': $vuetify.theme.dark }"
  >
    <v-container>
      <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">Contact</h2>

      <v-responsive class="mx-auto mb-12" width="56">
        <v-divider class="mb-1"></v-divider>

        <v-divider></v-divider>
      </v-responsive>

      <v-theme-provider light>
        <v-form ref="form" v-model="valid" @submit.prevent="doContact" lazy-validation>
          <v-row>
            <v-col cols="12" md="6" lg="4">
              <v-text-field
                flat
                label="Name*"
                v-model="contact.name"
                :rules="[(v) => !!v || 'Name is required']"
                required
                solo
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-text-field
                flat
                label="Email*"
                v-model="contact.email"
                :rules="[(v) => !!v || 'Email is required']"
                required
                solo
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-text-field
                flat
                label="Subject*"
                v-model="contact.subject"
                :rules="[(v) => !!v || 'Subject is required']"
                required
                solo
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-textarea
                flat
                label="Message*"
                v-model="contact.message"
                :rules="[(v) => !!v || 'Message is required']"
                required
                solo
              ></v-textarea>
            </v-col>

            <v-col class="mx-auto" cols="auto">
              <v-btn color="primary" type="submit" x-large>Submit</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-theme-provider>
    </v-container>
  </v-sheet>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data: () => ({
    contact: {},
    loading: false,
    valid: true,
    errors: {},
  }),
  created() {},
  mounted() {},
  computed: {},
  methods: {
    ...mapActions("contact", { sendContact: "create" }),
    ...mapActions("app", ["showMessage"]),
    validate() {
      return this.$refs.form.validate();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
      this.errors = {};
    },
    async doContact() {
      if (!this.validate()) return;

      try {
        await this.sendContact(this.contact);
        this.showMessage({
          text: "Thank you, message has been sent!",
          color: "green",
        });
        this.contact = {};
        this.resetValidation();
      } catch (error) {
        this.showMessage({
          text: "Failed to send message, please try again...",
          color: "error",
        });
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
</style>